import agency from './agency';
import bill from './bill';
import purse from './purse';
import recharge from './recharge';
import rule from './rule';
import task from './task';

export default {
  common: {
    success: 'Success',
    days: 'Days',
    task: 'Task',
    next: 'Next',
    previous: 'Previous',
    change: 'Change',
    noData: 'No Data',
    cancel: 'Cancel',
    rule: 'Rule',
    exchange: 'Exchange',
    confirm: 'Confirm',
    notice: 'Notice',
    send: 'Send',
    received: 'Received',
    recipient: 'Recipient',
    agency: 'Agency',
    country: 'Country',
    channel: 'Channel',
    account: 'Account',
    fullName: 'FullName',
    currency: 'Currency',
    bankName: 'BankName',
    bankCode: 'BankCode',
    address: 'Address',
    targetOrg: 'TargetOrg',
    save: 'Save',
    ID: 'ID: {{id}}',
    bank: 'Bank',
    invite: 'Invite',
    information: 'Information',
    edit: 'Edit',
    announce: 'Announcement',
    member: 'Member',
    taskn: 'Task {{n}}',
    fromAlbum: 'From Album',
    takePhoto: 'Take Photo',
    delete: 'Delete',
    supportCountry: 'Support Country',
    enter: 'Enter',
    noUser: 'no user found',
    enterId: 'Enter ID',
    recharge: 'Recharge',
    warning: 'Warning',
    topUp: 'Top up',
  },
  error: {
    systemFatal: 'Something went wrong. Please try again later.',
  },
  agency,
  bill,
  purse,
  recharge,
  rule,
  task,
};
